import {
  getMethod2,
  postMethod,
  postMethod2,
  postMethodWithErrorHandling,
  putMethod,
  uploadFile,
} from "./httpMethods";
// School
export const addSchool = (data, signal) => {
  return new Promise((resolve, reject) => {
    postMethod("school", data, signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
// Organization
export const addOrganization = (data) => {
  return new Promise((resolve, reject) => {
    postMethod("organizations", data)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
// User
export const addUser = (data) => {
  return new Promise((resolve, reject) => {
    postMethod("user", data)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
// Participant
export const addParticipant = (data, signal) => {
  return new Promise((resolve, reject) => {
    postMethodWithErrorHandling("participant", data, signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
export const uploadParticipantsCsv = (data, signal) => {
  return new Promise((resolve, reject) => {
    uploadFile("imports/participants", data?.file, data?.participants)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

// Upload Participant Answers
export const uploadParticipantAnswers = (data, signal) => {
  return new Promise((resolve, reject) => {
    postMethod("competition/upload_answers", data, signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
// Upload Participant Marks
export const uploadParticipantMarks = (data, signal) => {
  return new Promise((resolve, reject) => {
    postMethod("competition/upload_marks", data, signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
// Domain and Tag
export const addDomain = (data) => {
  return new Promise((resolve, reject) => {
    postMethod("tag", data)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
// Competition
export const addCompetition = (data) => {
  return new Promise((resolve, reject) => {
    postMethod("competition", data)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
export const addCompetitionOrganization = (data) => {
  return new Promise((resolve, reject) => {
    postMethod("competition/organization", data)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
export const addCompetitionRound = (data) => {
  return new Promise((resolve, reject) => {
    postMethod("competition/rounds", data)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
export const addCompetitionRoundAward = (data) => {
  return new Promise((resolve, reject) => {
    postMethod("competition/awards", data)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
export const addCompetitionOverallAward = (data) => {
  return new Promise((resolve, reject) => {
    postMethod("competition/overall_awards", data)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
export const addMarkingPreparation = (params, signal) => {
  return new Promise((resolve, reject) => {
    postMethod("marking/preparation", params, signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
// Task
export const addTask = (data) => {
  return new Promise((resolve, reject) => {
    postMethod("tasks", data)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
/**
 * Create task with the new combined payload. Resolves `{ data, status }` where `status` is the **HTTP** status
 * (so callers are not confused with optional `data.status` in the JSON body).
 */
export const createTaskPayload = (data) => {
  return new Promise((resolve, reject) => {
    postMethod2("tasks/v2/create", data)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
// Difficulty Group
export const addDifficultyGroup = (data) => {
  return new Promise((resolve, reject) => {
    postMethod("taskdifficultygroup", data)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
// Collection
export const addCollection = (data) => {
  return new Promise((resolve, reject) => {
    postMethod("collection", data)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
//addsection
export const addsection = (data) => {
  return new Promise((resolve, reject) => {
    postMethod("collection/sections", data)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
export const addGroup = (id, data) => {
  return new Promise((resolve, reject) => {
    postMethod(`marking/preparation/${id}`, data)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

//approve tasks
export const approveTask = (data) => {
  return new Promise((resolve, reject) => {
    postMethod(`tasks/approve`, data)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
//reject tasks
export const rejectTask = (id, data) => {
  return new Promise((resolve, reject) => {
    postMethod(`tasks/reject/${id}`, data)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const removeVerifyTask = (id) => {
  return new Promise((resolve, reject) => {
    postMethod(`tasks/unverify/${id}`)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

//approve collection
export const approveCollection = (data) => {
  return new Promise((resolve, reject) => {
    postMethod(`collection/approve`, data)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

//reject collection
export const rejectCollection = (id, data) => {
  return new Promise((resolve, reject) => {
    postMethod(`collection/reject/${id}`, data)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

//verfiy collection
export const verfiycollection = (id) => {
  return new Promise((resolve, reject) => {
    postMethod(`collection/verify/${id}`)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const BulkDownload = (params) => {
  return new Promise((resolve, reject) => {
    getMethod2(`participant/reports/bulk_download`, params)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

//remove verify collection
export const removeVerifyCollection = (id) => {
  return new Promise((resolve, reject) => {
    postMethod(`collection/unverify/${id}`)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

//duplicateTasks
export const duplicatetasks = (id) => {
  return new Promise((resolve, reject) => {
    postMethod(`tasks/duplicate/${id}`)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

//duplicateCollections
export const duplicateCollections = (id) => {
  return new Promise((resolve, reject) => {
    postMethod(`collection/duplicate/${id}`)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

//award_stats
export const AwardStats = (id, data) => {
  return new Promise((resolve, reject) => {
    postMethod(`marking/competition/groups/award_statics/compute/${id}`, data)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
export const AwardStatsPrecent = (data) => {
  return new Promise((resolve, reject) => {
    postMethod(`marking/competition/groups/award_statics/check_progress`, data)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const verfiyCollection = (data) => {
  return new Promise((resolve, reject) => {
    postMethod(`collection/verify`, data)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const verfiyTask = (id, data) => {
  return new Promise((resolve, reject) => {
    postMethod(`tasks/verify/${id}`)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const verfiyDiffPoints = (data) => {
  return new Promise((resolve, reject) => {
    postMethod(`collection/difficultyandpoints/verify`, data)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
export const refreshData = (id) => {
  return new Promise((resolve, reject) => {
    postMethod(`marking/refresh/${id}`)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
export const elemParticipants = (id, data, param) => {
  return new Promise((resolve, reject) => {
    postMethod(`participant/eliminate/${id}${param}`, data)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const postIdentifiedAnswerKeys = (data) => {
  return new Promise((resolve, reject) => {
    postMethod(`marking/possible_similar_answers`, data)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const confirmedCountries = (id, data) => {
  return new Promise((resolve, reject) => {
    postMethod(`competition/cheaters/confirmed-countries/${id}`, data)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

// {domain}}/marking/possible_similar_answers/update_answer
export const updateParticipantsAnswers = (data) => {
  return new Promise((resolve, reject) => {
    postMethod(`marking/possible_similar_answers/update_answer`, data)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const MarkParticipant = (id) => {
  return new Promise((resolve, reject) => {
    postMethod(`marking/participant/${id}`)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const MarkMMM = (id) => {
  return new Promise((resolve, reject) => {
    postMethod(`competition/team-based/simoc/${id}/mmm/compute`)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const MarkMW = (id) => {
  return new Promise((resolve, reject) => {
    postMethod(`competition/team-based/simoc/${id}/mw/compute`)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

//Post Team Competition Answers
export const PostTeamCompetitionAnswers = (id, data) => {
  return new Promise((resolve, reject) => {
    postMethod(`competition/team-based/simoc/${id}/question-sets`, data)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const uploadMMMCompetitionParticipantAnswers = async (file) => {
  const response = await uploadFile(
    "competition/team-based/2025-simoc/mmm/upload-answers",
    file
  );
  if (response?.config) {
    return response.data;
  }
  throw response;
};

export const uploadMWCompetitionParticipantAnswers = async (file) => {
  const response = await uploadFile(
    "competition/team-based/2025-simoc/mw/upload-answers",
    file
  );
  if (response?.config) {
    return response.data;
  }
  throw response;
};

export const uploadNonSimocCompetitionParticipantAnswers = async (
  file,
  competitionId
) => {
  const response = await uploadFile(
    `competition/team-based/${competitionId}/upload-answers`,
    file
  );
  if (response?.config) {
    return response.data;
  }
  throw response;
};

export const updateMWFinalAward = (id, data) => {
  return new Promise((resolve, reject) => {
    postMethod(`competition/team-based/simoc/${id}/mw/update_final_award`, data)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const updateMMMFinalAward = (id, data) => {
  return new Promise((resolve, reject) => {
    postMethod(
      `competition/team-based/simoc/${id}/mmm/update_final_award`,
      data
    )
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const generateNewCertificates = (payload) => {
  return new Promise((resolve, reject) => {
    postMethod(`certificates/generate`, payload)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const MakeAbsentParticipant = (id) => {
  return new Promise((resolve, reject) => {
    postMethod(`participant/mark-absent/${id}`)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const submitTeamMembersForTeamCompetition = (payload, competitionId) => {
  return new Promise((resolve, reject) => {
    //TODO: Update the endpoint to the correct one
    postMethod(`competition/team-based/simoc/${competitionId}/teams`, payload)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const submitNonSimocTeamMembersForTeamCompetition = (
  payload,
  competitionId
) => {
  return new Promise((resolve, reject) => {
    //TODO: Update the endpoint to the correct one
    postMethod(`competition/team-based/${competitionId}/teams`, payload)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const generateChampions = (id) => {
  return new Promise((resolve, reject) => {
    postMethod(`competition/team-based/simoc/${id}/generate-champions`)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

// export const uploadTeamMembersCsv = (payload) => {
//   return new Promise((resolve, reject) => {
//     //TODO: Update the endpoint to the correct one
//     postMethod(`competition/team-based/2025-simoc/team-members/upload`, payload)
//       .then((d) => resolve(d))
//       .catch((e) => reject(e));
//   });
// };

export const configureAwardsCriteria = (id, payload) => {
  return new Promise((resolve, reject) => {
    postMethod(`competition/team-based/${id}/awards`, payload)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const computeTeamBasedCompetition = (id) => {
  return new Promise((resolve, reject) => {
    postMethod(`competition/team-based/${id}/compute`)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const computeTeamBasedCompetitionWithErrorHandling = (id) => {
  return new Promise((resolve, reject) => {
    postMethodWithErrorHandling(`competition/team-based/simoc/${id}/compute`)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const updateTeamBasedFinalAward = (id, payload) => {
  return new Promise((resolve, reject) => {
    postMethod(`competition/team-based/${id}/update_final_award`, payload)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

const processCertificateConfigurations = async (configurations) => {
  const configs = configurations || [];
  const awards = [];

  const configsNeedingUpload = configs
    .map((config, index) => ({ config, index }))
    .filter(({ config }) => config.selectedFile);

  const uploadResults = await Promise.all(
    configsNeedingUpload.map(({ config }) =>
      uploadFile("certificates/template/upload", config.selectedFile)
    )
  );

  const uploadResultByIndex = new Map();
  configsNeedingUpload.forEach(({ config, index }, i) => {
    const uploadRes = uploadResults[i];
    if (!uploadRes?.data) throw uploadRes || new Error("Upload failed");
    const path =
      uploadRes.data?.path ??
      uploadRes.data?.file_id ??
      uploadRes.data?.id ??
      null;
    if (!path) throw new Error("Upload did not return path");
    uploadResultByIndex.set(index, {
      path,
      file_name: config.selectedFile.name,
    });
  });

  for (let i = 0; i < configs.length; i++) {
    const config = configs[i];
    let path, file_name;
    if (config.selectedFile) {
      const resolved = uploadResultByIndex.get(i);
      path = resolved.path;
      file_name = resolved.file_name;
    } else if (config.file_id) {
      path = config.file_id;
      file_name = config.file_name || "template.pdf";
    } else {
      continue;
    }
    const awardNames = Array.isArray(config.awards) ? config.awards : [];
    const showDisclaimer = config.showDisclaimer || false;
    for (const award of awardNames) {
      const awardValue =
        typeof award === "object" ? award?.value ?? award : award;
      awards.push({
        award: awardValue,
        show_disclaimer: showDisclaimer,
        file_name: file_name || "template.pdf",
        path,
      });
    }
  }

  return awards;
};

export const addNewCompetitionInPrintCertificates = async (data) => {
  const awards = await processCertificateConfigurations(data.configurations);

  const payload = {
    name: data.configuration_name || "",
    round_id: data.round_id,
    is_team_round: Boolean(data.is_team_round),
    awards,
  };
  if (data.allowed_roles) {
    payload.roles = data.allowed_roles
      .split(",")
      .map((s) => parseInt(s.trim(), 10))
      .filter((n) => !isNaN(n));
  }
  if (data.country_id != null && data.country_id !== "") {
    payload.countries = [data.country_id];
  }
  if (data.organization_ids != null && data.organization_ids?.length) {
    payload.organizations = data.organization_ids;
  }

  const response = await postMethod("certificates/template", payload);
  if (response && response.errors) {
    throw response;
  }
  return response;
};

export const updateCertificateConfiguration = async (id, data) => {
  const awards = await processCertificateConfigurations(data.configurations);

  const payload = {
    name: data.configuration_name || "",
    round_id: data.round_id,
    is_team_round: Boolean(data.is_team_round),
    awards,
  };
  if (data.allowed_roles) {
    const roles = data.allowed_roles
      .split(",")
      .map((s) => parseInt(s.trim(), 10))
      .filter((n) => !isNaN(n));
    if (roles.length) payload.roles = roles;
  }
  if (data.country_ids != null && data.country_ids?.length) {
    payload.countries = data.country_ids;
  } else if (data.country_id != null && data.country_id !== "") {
    payload.countries = [data.country_id];
  }
  if (data.organization_ids != null && data.organization_ids?.length) {
    payload.organizations = data.organization_ids;
  }

  const response = await putMethod(`certificates/template/${id}`, payload);
  if (response && response.errors) {
    throw response;
  }
  return response;
};

// Translations - Assignments
export const addAssignment = (data) => {
  return new Promise((resolve, reject) => {
    postMethod("translations/assignments", data)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

// Translations - Contest paper export
export const exportContestPaper = (data) => {
  return new Promise((resolve, reject) => {
    postMethod("translations/exports/contest-paper", data)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

// Backend endpoint not yet provided: stubbed locally so admins can build/save configs in the UI.
export const saveExportConfiguration = (data) => {
  console.warn(
    "[TODO] POST /translations/exports/configurations endpoint not provided by backend yet - resolving locally"
  );
  return Promise.resolve({
    status: 200,
    message: "Configuration saved locally (stub)",
    data,
  });
};
